import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import LandingPage from './components/LandingPage.js';
import BlogHubPage from './components/blog/BlogHubPage.js';
import BlogPostPage from './components/blog/BlogPostPage.js';
import PowerBIServicePage from './components/services/PowerBIServicePage.js';
import "./App.css";

function App() {
  const isPreview = process.env.REACT_APP_VERCEL_ENV === 'preview' || process.env.NODE_ENV === 'development';
  const isProduction = process.env.REACT_APP_VERCEL_ENV === 'production';

  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Routes>
            {/* Landing Page Principal */}
            <Route
              path="/"
              element={
                <LandingPage
                  showPendingTasks={!isProduction}
                  isPreview={isPreview}
                />
              }
            />

            {/* Página de Servicio: Power BI & Business Intelligence */}
            <Route
              path="/servicios/power-bi-business-intelligence"
              element={<PowerBIServicePage />}
            />

            {/* Hub de Blog */}
            <Route
              path="/blog"
              element={<BlogHubPage />}
            />

            {/* Artículos Individuales del Blog */}
            <Route
              path="/blog/:slug"
              element={<BlogPostPage />}
            />

            {/* Redirección por defecto ante rutas desconocidas */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
